import { render, staticRenderFns } from "./base-steps-view.vue?vue&type=template&id=fb2cb04a&scoped=true&"
import script from "./base-steps-view.vue?vue&type=script&lang=js&"
export * from "./base-steps-view.vue?vue&type=script&lang=js&"
import style0 from "./base-steps-view.vue?vue&type=style&index=0&id=fb2cb04a&prod&scoped=true&lang=css&"
import style1 from "./base-steps-view.vue?vue&type=style&index=1&id=fb2cb04a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb2cb04a",
  null
  
)

export default component.exports